<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-29 10:22:56
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Punch\AbnormalPunchReason\editAbnormalPunchReason.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-09-06 15:03:11
-->
<template>
  <ContentLayout
    widthClass="max-1000"
    backgroundClass="white"
    :title="
      iSEdited
        ? $t('label_essweb_abnormalPunchReason_form_editTitle')
        : $t('label_essweb_abnormalPunchReason_form_viewTitle')
    "
    :initData="ReasonData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'punch_invalid_reason_name',
      'sequence',
      'punch_invalid_reason_description',
      'punch_invalid_reason_code',
      'remarks',
    ]"
    delBtn
    :editBtn="!iSEdited"
    @edit="iSEdited = true"
    @delete="
      $confirmDo($t('label_essweb_abnormalPunchReason_list_title')).then(
        (res) => {
          res ? toDelete() : null;
        }
      )
    "
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-form ref="form" lazy-validation>
        <v-row align="center" justify="start">
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :filled="iSEdited"
              maxlength="100"
              :readonly="!iSEdited"
              :bindData="ReasonData.punch_invalid_reason_name"
              @change="
                (valueArr) => {
                  ReasonData.punch_invalid_reason_name = valueArr;
                }
              "
              :label="$t('label_essweb_abnormalPunchReason_form_nameLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              :filled="iSEdited"
              :readonly="!iSEdited"
              maxlength="255"
              type="number"
              isNotRequire
              :rules="
                $GetRules(['_Number_negative', '_Length_Rules'], [null, 255])
              "
              :label="
                $t('label_essweb_abnormalPunchReason_form_sequennceLabel;')
              "
              v-model="ReasonData.sequence"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              :filled="iSEdited"
              :readonly="!iSEdited"
              maxlength="50"
              :label="$t('label_essweb_abnormalPunchReason_form_codeLabel')"
              v-model="ReasonData.punch_invalid_reason_code"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :filled="iSEdited"
              maxlength="500"
              :readonly="!iSEdited"
              :bindData="ReasonData.punch_invalid_reason_description"
              @change="
                (valueArr) => {
                  ReasonData.punch_invalid_reason_description = valueArr;
                }
              "
              :label="
                $t('label_essweb_abnormalPunchReason_form_descriptionLabel')
              "
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_abnormalPunchReason_form_remarkLabel")
            }}</v-sheet>
            <v-textarea
              rows="5"
              no-resize
              maxlength="500"
              :filled="iSEdited"
              :readonly="!iSEdited"
              dense
              single-line
              v-model="ReasonData.remarks"
              counter="500"
              name="input-7-4"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <!-- content -->
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        saveBtn
        @save="toSave"
        v-if="iSEdited"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <!-- tools -->
    <template v-slot:tools-main> </template>
    <!-- tools -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "editPunchVerifyFailedReason",
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
  },
  data() {
    return {
      iSEdited: true,
      isChanged: false,
      ReasonData: {
        punch_invalid_reason_name: "",
        sequence: 1,
        punch_invalid_reason_description: "",
        punch_invalid_reason_code: "",
        remarks: "",
      },
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_punch_invalid_reason",
        url: "/punch-invalid-reason/get-punch-invalid-reason-details/",
        data: {
          uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data["punch_invalid_reason_name_save"] =
          res.data.punch_invalid_reason_name;
        res.data.punch_invalid_reason_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.punch_invalid_reason_name
        );
        res.data["punch_invalid_reason_description_save"] =
          res.data.punch_invalid_reason_description;
        res.data.punch_invalid_reason_description =
          that.$transOnLineCommonLangKey(
            that.companyLang,
            res.data.punch_invalid_reason_description
          );
        that.ReasonData = res.data;
      });
    },
    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_punch_invalid_reason",
        url: "/punch-invalid-reason/delete-punch-invalid-reason-table/",
        data: {
          uuids: this.$route.params.id,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_abnormalPunchReason_list_deleteAbnormalPunchReasonSuccessLabel"
          ),
          type: "success",
        });
        that.$toBack();
      });
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_punch_invalid_reason",
        url: "/punch-invalid-reason/update-punch-invalid-reason-table/",
        data: {
          uuid: this.$route.params.id,
          punch_invalid_reason_code: this.ReasonData.punch_invalid_reason_code,
          sequence: this.ReasonData.sequence,
          punch_invalid_reason_name: this.$transCommonLangKey(
            this.ReasonData.punch_invalid_reason_name,
            this.ReasonData.punch_invalid_reason_name_save
          ),
          punch_invalid_reason_description: this.$transCommonLangKey(
            this.ReasonData.punch_invalid_reason_description,
            this.ReasonData.punch_invalid_reason_description_save
          ),
          remarks: this.ReasonData.remarks,
        },
      }).then((res) => {
        that.$toBack();
        that.$showMessage({
          text: that.$t(
            "message_essweb_abnormalPunchReason_list_updateAbnormalPunchReasonSuccessLabel"
          ),
          type: "success",
        });
      });
    },
  },
};
</script>
